import { connect } from "react-redux";
import TicketPage from "../components/TicketPage";
import * as actionsTicket from "../../../_actions/ticket";
import * as actionsDimension from "../../../_actions/dimension";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    //Ticket
    ticket: Ticket.data && Ticket.data.result,

    //Dimension
    languageListLoading: Dimension.Language.fetching.loading,
    languageList: Dimension.Language.languageList,
    countryListLoading: Dimension.Country.fetching.loading,
    countryList: Dimension.Country.countryList,
    // provinceListLoading: Dimension.Province.fetching.loading,
    // provinceList: Dimension.Province.provinceList,
    referencePlatformListLoading: Dimension.ReferencePlatform.fetching.loading,
    referencePlatformList: Dimension.ReferencePlatform.referencePlatformList,
    requestTypeListLoading: Dimension.RequestType.fetching.loading,
    requestTypeList: Dimension.RequestType.requestTypeList,
    returnReasonListLoading: Dimension.ReturnReason.fetching.loading,
    returnReasonList: Dimension.ReturnReason.returnReasonList,
    returnLabelLoading: Ticket.returnLabelFetching.loading,
    returnLabelLoadingError: Ticket.returnLabelFetching.err,

    //Misc
    language: Misc.Settings.language,
    authToken: Misc.Auth.token,
    authTokenLoading: Misc.Auth.fetching.loading
});

const mapDispatchToProps = dispatch => ({
    getCountryList: () => {
        dispatch(actionsDimension.getCountryList());
    },
    getProvinceList: () => {
        dispatch(actionsDimension.getProvinceList());
    },
    getReferencePlatformList: () => {
        dispatch(actionsDimension.getReferencePlatformList());
    },
    getRequestTypeList: () => {
        dispatch(actionsDimension.getRequestTypeList());
    },
    getReturnReasonList: () => {
        dispatch(actionsDimension.getReturnReasonList());
    },
    getReturnLabel: (ticketId, requestId) => {
        dispatch(actionsTicket.getReturnLabel(ticketId, requestId));
    },
    updateTicket: (ticketId, ticket) => {
        dispatch(actionsTicket.updateTicket(ticketId, ticket));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketPage);
